module.exports = __webpack_public_path__ + "static/media/loader.3b18029c.svg";